import { RootState } from '@app/redux/root-reducer';

export const selectOrderState = (store: RootState) => store.OrderSlice.order;
